module.exports = __webpack_public_path__ + "static/media/add-bank.dca09f72.jpg";